export const appHead = {"meta":[{"charset":"utf-8"},{"property":"og:type","content":"website"},{"property":"og:site_name","content":"Magvi"},{"property":"og:title","content":"Magvi — программа, которая создаёт инфографику для маркетплейсов"},{"property":"og:description","content":"В ней можно бесплатно удалить фон, добавить подходящие иконки, настроить шрифты, выбрать готовую инфографику из шаблонов и отредактировать ее."},{"property":"og:url","content":"https://magvi.ai"},{"property":"og:locale","content":"ru_RU"},{"property":"og:image","content":"https://magvi.ai/og-image.png"},{"property":"og:image:width","content":1200},{"property":"og:image:height","content":630},{"name":"viewport","content":"width=device-width,height=device-height,initial-scale=1.0,user-scalable=no;user-scalable=0;"}],"link":[{"rel":"icon","type":"image/x-icon","href":"/favicon.ico"}],"style":[],"script":[{"innerHTML":"\n      (function(m,e,t,r,i,k,a){m[i]=m[i]||function(){(m[i].a=m[i].a||[]).push(arguments)};\n      m[i].l=1*new Date();\n      for (var j = 0; j < document.scripts.length; j++) {if (document.scripts[j].src === r) { return; }}\n      k=e.createElement(t),a=e.getElementsByTagName(t)[0],k.async=1,k.src=r,a.parentNode.insertBefore(k,a)})\n      (window, document, \"script\", \"https://mc.yandex.ru/metrika/tag.js\", \"ym\");\n      ym(95519191, \"init\", {\n        clickmap:true,\n        trackLinks:true,\n        accurateTrackBounce:true,\n        webvisor:true\n      });\n    "}],"noscript":[],"htmlAttrs":{"lang":"ru-RU"}}

export const appBaseURL = "/"

export const appBuildAssetsDir = "/_nuxt/"

export const appCdnURL = ""

export const appLayoutTransition = false

export const appPageTransition = false

export const appKeepalive = false

export const appRootId = "__nuxt"

export const appRootTag = "div"

export const renderJsonPayloads = true

export const componentIslands = false

export const remoteComponentIslands = false

export const devPagesDir = null

export const devRootDir = null

export const vueAppRootContainer = '#__nuxt'